import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import ReduxToastr from 'react-redux-toastr';

import ResetCss from 'xpi-black-ui/Styles/global';
import CreateCacheLogin from './components/Common/CreateCacheLogin';
import Notification from './components/Common/Notification';
import GlobalStyle from './globalStyle';
import { CMSModalProvider } from './hooks/useCMSModal';
import Routes from './routes';

import { useNotificationContext } from './state/notification';

const AppContainer = () => {
  // eslint-disable-next-line no-unused-vars
  const [_, dispatch] = useNotificationContext();
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  // Show loading state while Auth0 is initializing
  if (isLoading) {
    return <div>Loading authentication...</div>;
  }

  // If user is not authenticated, redirect to Auth0 login
  if (!isAuthenticated) {
    loginWithRedirect();
    return <div>Redirecting to login...</div>;
  }

  return (
    <CMSModalProvider notificationDispatch={dispatch}>
      <div className="content">
        <Routes />
      </div>
      <CreateCacheLogin />
      <ReduxToastr
        newestOnTop
        progressBar
        timeOut={4000}
        closeOnToastrClick
        extendedTimeOut={4000}
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        confirmOptions={{ okText: 'Confirmar' }}
        preventDuplicates
      />
      <Notification />
      <ResetCss />
      <GlobalStyle />
    </CMSModalProvider>
  );
};

export default AppContainer;
